<template>
  <div class="merge-load-modal">
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="pull-right">
        <div class="btn-close" @click="close"></div>
      </div>
      <div class="content">
        <div>
          <h1 stlye="word-break: break-all;">Lastgang werte ergänzen</h1>
        </div>
        <form @submit.prevent="merge()">
          <div class="row">
            <div class="col-6">
              <label class="element-label" for="file">File (csv/excel)</label>
              <FilePicker
                id="file"
                class="file-input"
                accpetedFileTypes=".csv, .xls, .xlsx"
                @onFileSelected="onFileSelected"
                @onFileDelete="onFileDelete"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <label class="element-label" for="mode"
                >Wie soll mit überlappenden Zeiträumen umgegangen werden?</label
              >
              <div
                v-for="modeOption in mergeModeOptions"
                :key="modeOption.label"
                class="radioOption"
              >
                <input
                  :id="modeOption.label"
                  type="radio"
                  name="mode"
                  :value="modeOption.value"
                  :checked="modeOption.value == mergeLoads.mode"
                  @change="changeSelectedMergeMode(modeOption.value)"
                />
                <label :for="modeOption.label">{{ modeOption.label }}</label>
              </div>
            </div>
          </div>

          <button class="btn-black" type="submit">Lastgang ergänzen</button>
        </form>

        <div class="merge-loading" v-show="isLoading">
          <div class="progress-icon"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilePicker from '../core/FilePicker.vue';
export default {
  name: 'mergeLoadsModal',
  data() {
    return {
      mergeLoads: {
        mode: 'keep_existing_values',
        file: '',
      },
      mergeModeOptions: [
        {
          label: 'Vorhandene werte behalten',
          value: 'keep_existing_values',
        },
        {
          label: 'Vorhandene werte überschreiben',
          value: 'replace_existing_values',
        },
        {
          label: 'Fehler ausgeben',
          value: 'throw_error',
        },
      ],
    };
  },
  props: {
    selectedItem: { type: Object },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close: function () {
      this.$emit('close');
    },
    onFileSelected(file) {
      this.mergeLoads.file = file;
    },
    onFileDelete() {
      this.mergeLoads.file = '';
    },
    changeSelectedMergeMode(value) {
      this.mergeLoads.mode = value;
    },
    merge() {
      this.$emit('merge', this.mergeLoads);
    },
  },
  created() {
    // Add class to make background fixed
    document.body.classList.add('modal-open');
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },
  components: {
    FilePicker,
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 40%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  position: fixed;
  width: 50%;
  height: 450px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  overflow-y: scroll;
}
/* Style that has no refference*/
.heading {
  padding: 15px 15px 0px;
  text-align: left;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: left;
  padding: 103px 69px;
  padding-top: 20px;
}

.merge-load-modal .file-input {
  margin-bottom: 10px;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.btn-black {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-bottom: 25px;
  margin-top: 17px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  width: fit-content;
}

.btn-black:hover {
  color: #fff;
  border: 3px solid #353434;
  background-color: #353434;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: left;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  font-weight: 300;
  line-height: 1.5;
}

label {
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  padding-top: 0;
  padding-bottom: 9px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #464d5d;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 300;
}

input {
  border-radius: 0;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  width: 100%;
  margin-bottom: 0;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}

.option-list {
  clear: both;
  float: left;
  position: relative;
  width: 100%;
}

.option-list > ul {
  padding: 0;
  margin: 0;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  list-style: none;
}

.option-list ul li {
  float: left;
  clear: both;
  width: 100%;
  border-bottom: 1px solid #d8dee6;
  padding: 15px 0;
  font-size: 14px;
  color: #7e8890;
  line-height: 35px;
}

.option-list ul li.active {
  color: #323a45;
}

.radioOption {
  width: 100%;
}

.radioOption input {
  border: 0;
  background: transparent;
}

.radioOption input[type='text'] {
  width: 68%;
  margin-left: 9px;
  display: inline;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
  height: 43px;
  font-size: 15px;
}

.radioOption input[type='radio'] {
  width: 21px;
  float: left;
  margin-bottom: 0;
  height: 19px;
}

.merge-loading {
  background-color: #ffff;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.progress-icon {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 70px;
  height: 70px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
